import { Chakra } from "@airhelp/react-ui-components";
import config from "config/config";
import { useLanguage, useTranslations } from "contexts/LocalizationContext";
import Grid from "modules/common/components/Grid";
import getPageUrl from "utils/getPageUrl";
import { ArrowRightIcon } from "styles/icons";
import { ABOUT_EMAIL_ADDRESS, ABOUT_YOUTUBE_URL } from "./config";

const { Flex, Link, Box, Heading, Text, Image } = Chakra;

const About = () => {
  const translations = useTranslations();
  const language = useLanguage();

  const translationVariable = { "%press-mail-link-attrs%": `href="mailto:${ABOUT_EMAIL_ADDRESS}"` };

  const content = `${translations("if_youre_a_member", translationVariable)} <br/> ${translations(
    "only_media_inquiries"
  )}`;

  return (
    <Grid mb={0} py={{ base: 14, lg: 24 }}>
      <Box gridColumn={{ base: "span 1", md: "span 12" }}>
        <Flex justify="space-between" flexDir={{ base: "column", lg: "row" }}>
          <Heading variant="h2" as="h2">
            {translations("about_airhelp")}
          </Heading>
          <Link
            href={getPageUrl(language, "webappNewClaim")}
            alignSelf={{ base: "flex-start", lg: "flex-end" }}
            pt={{ base: 2, lg: 0 }}
            color="primary.500"
            fontSize="lg"
            isExternal
          >
            {translations("check_compensation")} <ArrowRightIcon w="11.77px" h="8.88px" />
          </Link>
        </Flex>
        <Flex justify={{ lg: "space-between" }} pt={{ base: 10, lg: 12 }} flexDir={{ base: "column", lg: "row" }}>
          <Flex flexDir="column" flexBasis={{ base: "auto", lg: "50vw" }}>
            <Text mb={2} fontSize="lg">
              {translations("airhelp_is_the_leading_specialist")}
            </Text>
            <Text color="greyscale.600" mb={6}>
              {translations("our_mission_is_to_help")}
            </Text>
            <Text mb={2} fontSize="lg">
              {translations("press_contact")}
            </Text>
            <Text
              color="greyscale.600"
              dangerouslySetInnerHTML={{
                __html: content,
              }}
              sx={{ a: { color: "primary.500", cursor: "pointer" } }}
            />
          </Flex>
          <Flex
            flexBasis={{ base: "auto", lg: "40vw" }}
            justify={{ base: "flex-start", md: "center", lg: "flex-end" }}
            align={{ base: "center", lg: "flex-start" }}
            pt={{ base: 12, lg: 0 }}
          >
            <Link href={ABOUT_YOUTUBE_URL} isExternal cursor="pointer">
              <Image src={`${config.staticUrl}/i/airhelp-score/section-about-decoration-img.svg`} />
            </Link>
          </Flex>
        </Flex>
      </Box>
    </Grid>
  );
};

export default About;
